/**
 * Scrollbars--滚动条
 * @Author: qizc
 * @Date:   2018-09-13 09:08:20
 * @Last Modified by:   qizc
 * @Last Modified time: 2018-10-18 13:04:37
 */
'use strict';

import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-patched';


export default class _Scrollbars extends React.Component {
    render() {
        const { children, getRef, ...restProps } = this.props;
        
        return (
            <Scrollbars
                ref={getRef}
                {...restProps}
            >
                {children}
            </Scrollbars>
        );
    }
}



// WEBPACK FOOTER //
// ./components/custom/Scrollbars/index.js